import { defineQuery, useQuery } from '@pinia/colada'
import { ref } from 'vue'
import { GetAllOrdersDTO } from '@trading/core'
import type { ID, OrderModel } from '@trading/core'

export const ORDERS_QUERY_KEY = 'orders'

export function getOrdersQueryKey(accountId: ID): ['orders', ID] {
  return [ORDERS_QUERY_KEY, accountId]
}

export function createOrdersQueryOptions(accountId: ID) {
  const { $wsOrderService } = useNuxtApp()

  return {
    key: getOrdersQueryKey(accountId),
    query: (): Promise<OrderModel[]> =>
      $wsOrderService.getAllOrders(new GetAllOrdersDTO(accountId)),
    staleTime: 60_000
  }
}

export const useOrdersQuery = defineQuery(() => {
  const { $wsOrderService } = useNuxtApp()

  const accountId = ref<ID | null>(null)

  const query = useQuery({
    key: () =>
      accountId.value == null ? [ORDERS_QUERY_KEY, 'empty'] : getOrdersQueryKey(accountId.value),
    // enabled, пока не выбран аккаунт — запрос не стартует
    enabled: () => accountId.value != null,
    query: () => $wsOrderService.getAllOrders(new GetAllOrdersDTO(accountId.value!)),
    staleTime: 60_000
  })

  return {
    ...query,
    accountId
  }
})
